import { render, staticRenderFns } from "./PostNavBtn.vue?vue&type=template&id=0285d84f&scoped=true"
import script from "./PostNavBtn.vue?vue&type=script&lang=js"
export * from "./PostNavBtn.vue?vue&type=script&lang=js"
import style0 from "./PostNavBtn.vue?vue&type=style&index=0&id=0285d84f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0285d84f",
  null
  
)

export default component.exports